<script setup lang="ts">
/** Status box: error, success, warning or neutral info, with a matching icon. */
withDefaults(defineProps<{
  type?: 'error' | 'success' | 'warning' | 'info'
  /** Hide the leading icon, e.g. for very short messages. */
  plain?: boolean
}>(), {
  type: 'info',
})

const icons = {
  error: 'bi-exclamation-circle-fill',
  success: 'bi-check-circle-fill',
  warning: 'bi-exclamation-triangle-fill',
  info: 'bi-info-circle-fill',
} as const
</script>

<template>
  <div class="notice flex items-start gap-3" :class="`notice-${type}`" role="status">
    <i v-if="!plain" :class="['bi', icons[type], 'mt-0.5 shrink-0']" />
    <div class="min-w-0 flex-1"><slot /></div>
  </div>
</template>
